export default __webpack_public_path__ + "static/media/navLine.ba6f8aef.svg";